var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "box-card",
        },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [_vm._v("组织信息")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has",
                      rawName: "v-has",
                      value: "myOrg:update",
                      expression: "'myOrg:update'",
                    },
                  ],
                  staticStyle: { padding: "3px 0" },
                  attrs: { type: "text" },
                  on: { click: _vm.updateUcOrg },
                },
                [_vm._v("更新")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has",
                      rawName: "v-has",
                      value: "myOrg:info",
                      expression: "'myOrg:info'",
                    },
                  ],
                  staticStyle: { float: "right", padding: "3px 0" },
                  attrs: { type: "text" },
                  on: { click: _vm.getUcOrgData },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticStyle: { margin: "0 20%  0 20%" },
                  attrs: { "label-width": "120px" },
                },
                [
                  _c("el-form-item", { attrs: { label: "组织类型" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.ucOrg.orgGroupName) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.ucOrg.createName
                    ? _c("el-form-item", { attrs: { label: "创建者" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.ucOrg.createName) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "创建时间" } }, [
                    _vm._v(
                      "\n         " +
                        _vm._s(_vm.ucOrg.createTimeFormat) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "组织名称" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ucOrg.orgName,
                          callback: function ($$v) {
                            _vm.$set(_vm.ucOrg, "orgName", $$v)
                          },
                          expression: "ucOrg.orgName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系人" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ucOrg.name1,
                          callback: function ($$v) {
                            _vm.$set(_vm.ucOrg, "name1", $$v)
                          },
                          expression: "ucOrg.name1",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系邮箱" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ucOrg.email1,
                          callback: function ($$v) {
                            _vm.$set(_vm.ucOrg, "email1", $$v)
                          },
                          expression: "ucOrg.email1",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系电话" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.ucOrg.mobile1,
                          callback: function ($$v) {
                            _vm.$set(_vm.ucOrg, "mobile1", $$v)
                          },
                          expression: "ucOrg.mobile1",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }